/**
 * The page whose record the router refused (organization-scoping 3.6c).
 *
 * A route handed a record by its id answers 403 `organizationNotAllowed` when
 * the record belongs to an organization this user may not use - a link or a
 * bookmark into the other organization. apiClient tells that apart from a
 * refused header and marks the page the request came from here; the shell
 * shows a message in that page's place (components/RecordAccessGate.jsx). A
 * plain module rather than React state, because the interceptor is not a
 * component - the same reason organizationScope.js is one.
 */

const listeners = new Set();

// The pathname of the page that was refused, or null.
let refusedPage = null;

const notify = () => {
  for (const listener of listeners) listener(refusedPage);
};

/** The pathname whose record was refused, or null. */
export function refusedRecordPage() {
  return refusedPage;
}

/** Marks a page as refused. A request with no page marks nothing. */
export function markRecordRefused(pathname) {
  if (!pathname || pathname === refusedPage) return;
  refusedPage = pathname;
  notify();
}

/** Forgets the refusal, so the next page loads as usual. */
export function clearRecordRefused() {
  if (refusedPage === null) return;
  refusedPage = null;
  notify();
}

/** Calls `listener(pathname)` on every change. Returns the unsubscribe. */
export function subscribeRecordRefused(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
